var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation",class:{
    hidden: _vm.hidden,
    'navigation--search-open': _vm.searchOpen,
    'navigation--top-position': _vm.onTopPosition,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }